export default {
    config: {
        defaultWidth: {
            default: 320
        },
    },
    default: {
        label: 'Report'
    },
    unique: [],
    lang: {
        name: 'Report',
        category: ['User', 'Plays'],
        description: 'Show report attached to the play.',
        views: ['sheet'],
    },
    filters: ['report.text', 'has.play.report']
}